import React, { useState, useEffect } from "react";
// import 'react-pagination-bar/dist/index.css'
import "./ReportCss/Report3.css"
// import "react-data-export";

// import "file-saver"
// import XSLX from "sheetjs-style"
// import FileSaver from "file-saver";

// import DialogSelect from '../../Components/Global/DialogSelect'

import ReportTable from '../../Components/Global/ReportTable'


const Report3 = (props) => {

  const {cntrct, cntComp, currentKey, reportData, setData, handleTab } = props
// , reportParams, ReportParamsSet, ColsParams, ColsParamsSet

//ColsParamsSet( !ColsParams ? [
  var ColsParams =[
    { Id: 'bld', Name: 'בניין', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 15},
    // { Id: 'flr', Name: 'קומה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 40},
    { Id: 'app', Name: 'דירה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 12},
    { Id: 'aliasName', Name: 'לקוח', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 65},
    { Id: 'room', Name: 'חדר', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 42},   
    { Id: 'gnrlDscrpt', Name: 'פ.מקור', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 65},  
    { Id: 'item', Name: 'פריט', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 40},    
    { Id: 'dscrpt', Name: 'תאור', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},          
    { Id: 'batch', Name: 'אצווה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 30},
    { Id: 'upgrdStt', Name: 'סטטוס', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 30},
    { Id: 'unitMsr', Name: 'י.מידה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 25},
    { Id: 'qty', Name: 'כמות כ"כ', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 30},
    { Id: 'dlvQty', Name: 'כ.סופקה', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 30},
    { Id: 'openQty', Name: 'כ.פתוחה', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 30},
    { Id: 'total', Name: 'סך ב₪', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 30},    
    { Id: 'shipDate', Name: 'תאריך', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 35},
    { Id: 'qutNum', Name: 'הזמנה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Title: 'currDocNum', Spcwidth: 25},
    { Id: 'dlnDoc', Name: 'ת.משלוח', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 25},
    { Id: 'dlnSign', Name: 'מ.אספ חתום', LinkImg: "/images/icons8-pdf-24.png", Spcwidth: 30, Title: 'dlnDoc' },
    { Id: 'invDoc', Name: 'חשבונית', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 25},
    // { Id: 'invCntrctDoc', Name: 'חש קבלן', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 30},
    ];// :ColsParams);

   // ReportParamsSet( !reportParams?  {NumRowsPerPage: window.innerHeight / 25, FreeSearch: ''} : reportParams );
   var reportParams = {NumRowsPerPage: window.innerHeight / 25, FreeSearch: ''} ;

// const url = 'https://proxy.tuboul.co.il/GetRpt2PA?cntrctNum=' + cntrct + '&comp=' + cntComp + '';
const url = '/GetRpt2PA?cntrctNum=' + cntrct + '&comp=' + cntComp + '';
 

  return (
    <div className="rpt"  >
      <ReportTable  cntrct={cntrct} cntComp={cntComp} currentKey={currentKey}
              reportParams={reportParams} colsParam={ColsParams}
               urlParam={url} 
              reportData={reportData} setReportData={setData} handleTab={handleTab}></ReportTable> 
 
          {/* <tbody>
         
            <tr style={{ whiteSpace: pageViewT != '2' ? "pre-wrap" : "nowrap" }}>
              <td>{row.bld}</td>
              <td>{row.flr}</td>
              <td>{row.app}</td>
              <td title={row.aliasName}>{row.aliasName.substr(0, 30)}</td>
              <td title={"מסמך- " + row.currDocNum}>{row.qutNum}</td>
              <td>{row.room}</td>
              <td>{row.item}</td>
              <td className="dtDscrpt" title={row.dscrpt}>{row.dscrpt.substr(0, 30)}</td>
              <td title={row.gnrlDscrpt}>{row.gnrlDscrpt.substr(0, 30)}</td>
              <td>{row.batch}</td>
              <td>{row.stt}</td>
              <td>{row.upgrdStt}</td>
              <td>{row.unitMsr}</td>
              <td data-field="number">{new Intl.NumberFormat().format(row.qty)}</td>
              <td type="number">{new Intl.NumberFormat().format(row.dlvQty)}</td>
              <td data-field="number">{new Intl.NumberFormat().format(row.openQty)}</td>
              <td data-field="number" title={new Intl.NumberFormat().format(row.total.replace(/,/g, ''))}>{new Intl.NumberFormat().format(row.total.replace(/,/g, ''))}</td>
              <td data-field="date">{row.shipDate}</td>
              <td data-field="note" data-sortable="true">{row.invDoc}</td>
            </tr>
        
        </tbody>
        <tfoot>
        </tfoot>
      </table>  */}


      {/* <tr>

     <div>
        <Pagination
        //  currentPage={this.state.currentPage}
          totalPages={10}
        //  changeCurrentPage={this.changeCurrentPage}
          theme="bottom-border"
        />
        <h2>current Page:{this.state.currentPage}</h2>
      </div>

     <button 
    //  onClick={setPreviousPage} disabled={!previousEnabled}
     >
                Previous Page
            </button>
            <span>
                { Current Page: {currentPage} of {totalPages} }
            </span>
            <button 
            // onClick={setNextPage} disabled={!nextEnabled}
            >
                Next Page
            </button>
     </tr> */}




    </div>

  );

};
export default Report3;


/*<script>
  $(function() {
    $('#table').bootstrapTable()
  })
</script>*/


//<BootstrapTable keyField='id' data={ data } columns={ columns } filter={ filterFactory() } />